import { render } from "./EstimateBox.vue?vue&type=template&id=8dd3804c"
import script from "./EstimateBox.vue?vue&type=script&lang=js"
export * from "./EstimateBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__